import { cn, Typography } from '@execonline-inc/execonline-ui';
import { DisplayTypeOptionProps } from './Types';

function DisplayTypeOption({
  label,
  icon,
  isSelected,
  onSelect,
  intercomTarget,
}: DisplayTypeOptionProps) {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={isSelected}
      className={cn(
        'flex flex-col items-center cursor-pointer rounded-lg border-2 px-4 py-3 transition-colors w-[145px]',
        isSelected ? 'border-primary bg-muted' : 'border-border hover:border-primary/50',
      )}
      onClick={onSelect}
      data-intercom-target={intercomTarget}
    >
      <div className="flex items-center gap-2 mb-2">
        <span
          className={cn(
            'flex items-center justify-center w-4 h-4 rounded-full border-2',
            isSelected ? 'border-primary bg-primary' : 'border-border bg-card',
          )}
          aria-hidden="true"
        >
          {isSelected && <span className="w-1.5 h-1.5 rounded-full bg-primary-foreground" />}
        </span>
        <Typography className={cn('text-sm font-medium', isSelected && 'text-primary')}>
          {label}
        </Typography>
      </div>
      <div className="flex justify-center" aria-hidden="true">
        {icon}
      </div>
    </button>
  );
}

export default DisplayTypeOption;
